export default __webpack_public_path__ + "static/media/maisons_laffitte6.650d6b4d.jpg";